import { Instant } from '@js-joda/core';
export const PeriodType = {
    second: 's',
    minute: 'm',
    hour: 'h',
    day: 'd',
    week: 'W',
    month: 'Mo',
    quarter: 'Q',
    year: 'Y',
};
const PeriodTypeDict = PeriodType;
export const PeriodNames = Object.keys(PeriodType);
Object.freeze(PeriodNames);
export const PeriodNameMap = new Map(PeriodNames.map((name) => [PeriodTypeDict[name], name]));
Object.freeze(PeriodNameMap);
export const PeriodTypes = PeriodNames.map((x) => PeriodTypeDict[x]);
Object.freeze(PeriodTypes);
/** 1-based indexing for Mon-Sun (ISO standard), 0-based indexing for Sun-Sat */
export const WeekdayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
Object.freeze(WeekdayNames);
export const WeekdayNumbersByName = new Map(WeekdayNames.slice(1).map((name, index) => [name.substring(0, 2), index + 1]));
Object.freeze(WeekdayNumbersByName);
export const HistoryType = {
    realtime: 'realtime',
    lookback: 'lookback',
    static: 'static',
    dynamic: 'dynamic',
    count: 'count',
};
export function isPointInTime(x) {
    return isRelativePointInTime(x) || isAbsolutePointInTime(x) || isBarCountPointInTime(x);
}
export function isRelativePointInTime(x) {
    if (typeof x !== 'object') {
        return false;
    }
    if (x === null) {
        return true;
    }
    return 'periods' in x;
}
export function isAbsolutePointInTime(x) {
    return typeof x === 'object' && x instanceof Instant;
}
export function isBarCountPointInTime(x) {
    return typeof x === 'number';
}
export function isTimeframe(x) {
    if (typeof x !== 'object') {
        return false;
    }
    if (x === null) {
        return true;
    }
    return 'start' in x && isPointInTime(x.start);
}
export function isSlidingWindow(x) {
    if (typeof x !== 'object') {
        return false;
    }
    if (x === null) {
        return true;
    }
    return 'value' in x;
}
export function compareSlidingWindow(a, b) {
    return a.period === b.period && a.value === b.value;
}
export function comparePointsInTime(a, b) {
    if (a === b) {
        return true;
    }
    if (isAbsolutePointInTime(a) && isAbsolutePointInTime(b)) {
        return a.compareTo(b) === 0;
    }
    if (isRelativePointInTime(a) && isRelativePointInTime(b)) {
        if (!a) {
            return false;
        } // b can't be !b also because we checked a === b already
        return a.anchor === b.anchor && a.periods.every((ap) => b.periods.some((bp) => compareSlidingWindow(ap, bp)));
    }
    return false;
}
//# sourceMappingURL=timeframe.js.map